<template>
  <Colleagues>

    <Loader v-if="loading"/>

    <section v-else-if="colleagues.length > 0" v-for="user in colleagues" class="media d-flex flex-wrap align-items-center">
      <figure class="media-left mb-1">
        <img :src="user.avatar_url" class="image is-64x64">
      </figure>
      <div class="media-content">
        <div class="content d-flex flex-wrap flex-column">
          <strong>{{ user.name || user.email }}</strong>

          <div v-if="user.school">
            <label class="fw-500">School</label>
            <small>{{ user.school }}</small>
          </div>

          <div v-if="user.position">
            <label class="fw-500">Position</label>
            <small>{{ user.position }}</small>
          </div>

          <div v-if="user.content_area">
            <label class="fw-500">Content Area</label>
            <small>{{ user.content_area }}</small>
          </div>

          <div v-if="user.grade">
            <label class="fw-500">Grade</label>
            <small>{{ user.grade }}</small>
          </div>
        </div>
      </div>
      <div class="media-right align-self-center d-flex justify-content-end grow-1">
        <button class="button is-danger is-outlined" @click="removeColleague(user)">Remove</button>
      </div>
    </section>

    <section v-else>
      <p class="text-center fs-7 text-muted mt-4">You don't have any colleagues yet.<p>
      <p class="text-center fs-5 text-muted">Visit the "Find Colleagues" tab above to add some.</p>
    </section>
    <Confirm :show="confirmShow" :title="confirmTitle" :message="confirmMessage" :confirmFocus="true" :completeButtonText="'Remove'" @cancel="cancelAction" @confirm="confirmAction"/>
  </Colleagues>
</template>

<script>
import Confirm from './Confirm'
import Colleagues from './Colleagues'
import Loader from './Loader'
import store from '../store'

import {
  fetchUser,
} from '../actionTypes'

export default {
  name: 'MyColleagues',
  components: {
    Colleagues,
    Loader,
    Confirm,
  },
  mounted () {
    this.loading = true
    store.dispatch(fetchUser)
    .then(() => {
      this.loading = false
    })
  },
  computed: {
    colleagues () {
      return store.state.user.colleagues
    },
  },
  data () {
    return {
      loading: false,
      confirmShow: false,
      confirmMessage: '',
      confirmTitle: '',
      actionColleague: null,
    }
  },
  methods: {
    cancelAction () {
      this.confirmShow = false
    },
    confirmAction () {
      this.confirmShow = false
      console.log(this.actionColleague)
      store.dispatch('removeColleague', { colleague: this.actionColleague })
    },
    removeColleague (colleague) {
      this.confirmShow = true
      const name = colleague.name || colleague.email
      const message = `Are you sure that you want to remove "${name}" from your My Colleagues page?`
      this.actionColleague = colleague
      this.confirmMessage = message
      this.confirmTitle = 'Remove Colleague'
    },
  }
}
</script>



// WEBPACK FOOTER //
// MyColleagues.vue?59b8414d